import React, {useEffect, useState} from "react";
import {Col, Container, Image, Row, Button, Figure, Spinner, Table, Stack, Form} from "react-bootstrap";
import UserInfo from "../modals/UserInfo";
import SubscriptionForm from "../forms/SubscriptionForm";
import axios from "axios";
import LoadingSpinner from "../toolkit/LoadingSpinner";
import {useNavigate, useLocation} from "react-router-dom";
import RemoveConfirmation from "../modals/RemoveConfirmation";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import SendConfirmation from "../modals/SendConfirmation";
import MissingReceipt from "../modals/MissingReceipt";

import {useStockStorage} from "../../hooks/useStockStorage";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";
import {reportTranspileErrors} from "ts-loader/dist/instances";
import EditSubscription from "../modals/EditSubscription";



/*
*
*  <Row>
                <UserInfo />
                <Col className={'col-7 mx-auto my-4'}>
                    <Container className={'panel center'}>
                        <SubscriptionForm />
                    </Container>
                </Col>
            </Row>
* */


type summary = {
    stock_value: string
    subscriptions: any | null
}

const Summary = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const {getStockStorageToken, removeStockStorageToken } = useStockStorage();
    const{getAppUniqueToken} = useAppUniqueToken();

    const [uaToken, setUaToken] = useState(getStockStorageToken);

    const [showMissingReceiptModal, setShowMissingReceiptModal] = useState(false);
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [showSendModal, setShowSendModal] = useState(false);
    const [idToConfirm, setIdToConfirm] = useState<string>()
    
    const [showEditModal, setShowEditModal] = useState(false);
    const [editItem, setEditItem] = useState();

    const [isLoading, setLoading] = useState(true)
    const [data, setData] = useState<summary | null>(null)
    const [subscriptionCount, setSubscriptionCount] = useState(0);

    const [filePath, setFilePath] = useState('');

    const [referenceYear, setReferenceYear] = useState<string>()

    useEffect(() => {
        window.scroll(0, 0);
        setLoading(true);
        
        getSummary();
        getRefenceYear();
            /*.then(() => {

                for(let i=0; i<data?.subscriptions.length; i++){
                    console.log('data?.subscriptions: ' + data?.subscriptions[i]);
                }
            });*/
    }, []);

    const getRefenceYear = async () => {
        setLoading(true);
        let system_reference_year = await axios.get('api/system-reference-year')
        .then(response => {
            setReferenceYear(response.data.result);
            setLoading(false);
        });
    };

    const getSummary = async () => {
        //alert('getSummary - uaToken: ' + uaToken);

        const payload = {
            uaToken
        };

        let currenSummaryObj = await axios.post('api/summary', payload)
            .then(response => {
                //console.log('getSummary from axios: ' + response.data.summary);
                setData(response.data.summary);
                //console.log('getSummary response.data.summary.subscriptions.length: ' + response.data.summary.subscriptions.length);
                setSubscriptionCount(response.data.summary.subscriptions.length);
                //console.log(response.data.summary);

                setLoading(false);
            });
    };

    const handleSend = () => {
        if(subscriptionCount > 0)
        {
            if(data?.stock_value.toString() !== '0')
            {
                let v = validateSelectedFile();

                if(!selectedFile)
                    setShowMissingReceiptModal(true)
                else
                {
                    if(!v)
                        toast.error(t('messages.errorWrongFileSize'));

                    setShowSendModal(v);
                }
            }
            else
                setShowSendModal(true);
        }
    };

    const handleRemove = (id:string) => {
        setIdToConfirm(id);
        setShowRemoveModal(true);
    };

    const handleEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item:any) => {
        e.preventDefault();
        e.stopPropagation();
        
        setEditItem(item);
        setShowEditModal(true);
    };

    const handleCancel = () => {
        if(uaToken === getAppUniqueToken())
            navigate('/');
        else
            navigate('/lounge');
    }


    const [isValidFile, setIsValidFile] = useState(true);
    const [selectedFile, setSelectedFile] = useState<HTMLInputElement>();
    const handleFileChange = (e: any) => {
        if(e.target.files.length > 0){
            setSelectedFile(e.target.files[0]);
        }
    };

    const validateSelectedFile = (): boolean => {
        const MIN_FILE_SIZE = 1024 // 1MB
        const MAX_FILE_SIZE = 7168 // 5MB


        if (!selectedFile) {
            //alert("Please choose a file");
            return false
        }

        const fileSizeKiloBytes = selectedFile.size / 1024
        /*if(fileSizeKiloBytes < MIN_FILE_SIZE){
            alert("File size is less than minimum limit");
            setIsValidFile(false);
            return
        }*/
        //setIsValidFile(true);

        if(fileSizeKiloBytes > MAX_FILE_SIZE) {
            //toast.error(t('messages.errorWrongFileSize'));
            //setIsValidFile(false);

            return false;
        }

        return true;
    };


    return (
        <Container fluid>
        {
        (
            isLoading ?
                <LoadingSpinner />
                :
                <div className="col col-lg-10 mx-auto my-4">
                    <div className="panel center">

                        <figure className="add_bottom_30">
                            <img src="img/europaverde.png" height="100px" alt="" /><br />
                            <h4>Tesseramento Europa Verde {referenceYear}</h4>
                        </figure>
                        {
                            data && (
                                <>
                                <div className="info-importo">
                                Controlla l’elenco delle richieste di tesseramento inserite, nel caso di errore puoi Rimuovere una o più richieste.<br/>
                                Nel caso sia tutto corretto puoi procedere con il caricamento della copia del bonifico effettuato e completare l’invio premendo il tasto "CONFERMA E INVIA"
                                <br />
                                <br />
                                <br />
                                <Table size={'sm'} hover={true} responsive={true}>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{t('labels.name')}</th>
                                        <th>{t('labels.surname')}</th>
                                        <th>{t('labels.fiscalCode')}</th>
                                        <th>{t('labels.town')}</th>
                                        <th>{t('labels.subscriptionQuote')}</th>
                                        <th colSpan={2}></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        data.subscriptions.map((item: any, i: number) => (
                                                <tr key={item.id}>
                                                    <td>{ i + 1 }</td>
                                                    <td>{ item.person_name }</td>
                                                    <td>{ item.person_surname }</td>
                                                    <td>{ item.person_fiscal_code }</td>
                                                    <td>{ item.person_town }</td>
                                                    <td>{ item.subscription_value } €</td>
                                                    <td width={40}> 
                                                        <Button className="btn_1 full-width text-white mb-1" 
                                                            variant="primary" 
                                                            // disabled={isLoading}
                                                            onClick={(e) => handleEdit(e, item)}
                                                        >
                                                            {t('captions.edit')}
                                                        </Button>
                                                    </td>
                                                    <td width={40}>
                                                        
                                                        <Button key={'btn_clean'} id={'btn_clean'} className={'btn_1 mb-1 full-width'} variant='danger' 
                                                            onClick={(e) => handleRemove(item.id)}
                                                        >
                                                             {t('captions.remove')}
                                                        </Button>

                                                        {/* <button className="btn_1 green" onClick={() => handleRemove(item.id)}>
                                                            {t('captions.remove')}
                                                        </button> */}
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    }
                                    <tr key={'stock_value'}>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td colSpan={3}><b>{t('labels.total')}: { data.stock_value } €</b></td>
                                    </tr>
                                    </tbody>
                                </Table>

                                </div>
                                {
                                    data.stock_value.toString() !== '0' &&
                                    (
                                        <div className="info-importo">
                                            Per inviare la richiesta è necessario allegare la ricevuta di pagamento effettuata tramite bonifico bancario<br />
                                            <Form.Group controlId="formFile" className="mb-3 mt-3">
                                                <Form.Label className="small">Formato file allegabili: .png, .jpg, .jpeg, .pdf, .doc, .docx</Form.Label>
                                                <Form.Control type="file"
                                                              accept={'.png, .jpg, .jpeg, .pdf, .doc, .docx'}
                                                              onChange={(e) => handleFileChange (e)}
                                                />
                                                <Form.Label className={'small float-end'}>{t('labels.maxFileSize')}: 7MB</Form.Label>
                                                {
                                                    selectedFile &&
                                                    (
                                                        <Button key={'DeleteReceipt'} id={'DeleteReceipt'} variant="outline-danger" className={'mt-2'} onClick={() => window.location.reload()}>
                                                            {t('captions.removeReceipt')}
                                                        </Button>
                                                    )
                                                }
                                                <br /><br />
                                            </Form.Group>
                                        </div>
                                    )
                                }
                                </>
                            )
                        }
                        <UserInfo 
                            showSection={'utent-riepilogoe'} 
                            customToken={uaToken} 
                            customTokenStatus={uaToken === getAppUniqueToken() ? 'STATUS_OPEN' : 'STATUS_SAVED'}
                        />
                        <div className="gestione centered">
                            <button className="btn_1 full-width green" onClick={() => handleSend()}>{t('captions.confirmAndSend')}</button>
                            <button className="btn_1 full-width yellow" onClick={() => handleCancel()}>{t('captions.goBack')}</button><br />
                            <center>
                                Cliccando sul tasto Torna indietro potrai continuare ad inserire altri nominativi
                            </center>
                        </div>

                    </div>

                    <MissingReceipt  show={showMissingReceiptModal}
                                     customToken={uaToken}
                                     onHide={() => setShowMissingReceiptModal(false)}/>
                    <SendConfirmation show={showSendModal}
                                      customToken={uaToken}
                                      receiptFile={selectedFile}
                                      onHide={() => setShowSendModal(false)} />
                    <RemoveConfirmation elementType={'subscription'}
                                        show={showRemoveModal}
                                        onHide={() => setShowRemoveModal(false)}
                                        customID={idToConfirm} 
                                        customToken={uaToken} />
                    <EditSubscription
                        show={showEditModal}
                        onHide={() => setShowEditModal(false)}
                        subscriptionData={editItem} 
                        customToken={uaToken} />

                </div>
        )
        }
        </Container>
    );
};

/*<div className="gestione centered">
                           <button type="submit" className="btn_1 full-width green" onClick={handleResetForm}>
                               <a href="#">Inserisci altro nominativo</a>
                           </button>
                           <button type="submit" className="btn_1 full-width yellow" onClick={handleSubmitForm}>
                               <a href="#">Termina e invia</a>
                           </button>
                       </div>*/

export default Summary;
